module.exports = __webpack_public_path__ + "img/logo.ed180d2f.png";